import {getLocale} from "../locale/AppLocale";

export default class Config {

    static routerLocale() {
        if (getLocale().code == 'ar') {
            return '';
        }
        return getLocale().code + '/';
    }

    static mainUrl(uri = '') {
        const r = this.routerLocale();
        return `https://www.shooq.co.il/${r}` + uri;
    }

    static api(uri = '') {
        const r = this.routerLocale();
        return `https://www.shooq.co.il/${r}sell-api/` + uri;
    }

    static accountsApi(uri = '') {
        const r = this.routerLocale();

        return `https://accounts.shooq.co.il/${r}sell-api/` + uri;
    }

    static withCredentials() {
        return true
    }
};
